import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TestimonialSection = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: "Priya & Arjun Sharma",
      location: "Bay Area, California",
      weddingType: "Punjabi-Hindu Fusion",
      image: "https://images.unsplash.com/photo-1606800052052-a08af7148866?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      rating: 5,
      testimonial: `ShaadiNest made our wedding planning so much easier! We found our perfect mehndi artist, photographer, and DJ all in one place. The cultural specialization filters helped us find vendors who truly understood our traditions. Our wedding was everything we dreamed of and more.`,
      vendorsBooked: 6,
      savings: 3500,
      highlight: "Found 6 perfect vendors in just 2 weeks"
    },
    {
      id: 2,
      name: "Kavya & Michael Johnson",
      location: "New York, NY",
      weddingType: "Interfaith Celebration",
      image: "https://images.pexels.com/photos/1024993/pexels-photo-1024993.jpeg?auto=compress&cs=tinysrgb&w=400&q=80",
      rating: 5,
      testimonial: `As an interfaith couple, we were worried about finding vendors who could blend both our traditions beautifully. ShaadiNest's interfaith category was a lifesaver! Our wedding perfectly honored both cultures, and our families were thrilled with how everything came together.`,
      vendorsBooked: 8,
      savings: 2800,
      highlight: "Perfect blend of two beautiful traditions"
    },
    {
      id: 3,
      name: "Ravi & Sneha Patel",
      location: "Houston, Texas",
      weddingType: "Traditional Gujarati",
      image: "https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      rating: 5,
      testimonial: `The vendor quality on ShaadiNest is exceptional! Every vendor we contacted was professional, experienced, and understood our Gujarati traditions perfectly. The review system helped us make confident decisions, and our wedding was absolutely magical.`,
      vendorsBooked: 7,
      savings: 4200,
      highlight: "Saved $4,200 with transparent pricing"
    },
    {
      id: 4,
      name: "Anjali & David Kim",
      location: "Chicago, Illinois",
      weddingType: "South Indian-Korean Fusion",
      image: "https://images.unsplash.com/photo-1519741497674-611481863552?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      rating: 5,
      testimonial: `Planning a multicultural wedding seemed overwhelming until we found ShaadiNest. The platform's diversity and the vendors' willingness to create something unique for us was incredible. Our South Indian-Korean fusion wedding was a beautiful celebration of both our heritages.`,
      vendorsBooked: 9,
      savings: 3100,
      highlight: "Created a unique multicultural celebration"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTestimonial((prev) => 
        prev === testimonials.length - 1 ? 0 : prev + 1
      );
    }, 6000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Icon
        key={index}
        name="Star"
        size={16}
        color={index < rating ? "#DAA520" : "#E8E2DD"}
        className={index < rating ? "fill-current" : ""}
      />
    ));
  };

  const currentTestimonialData = testimonials[currentTestimonial];

  return (
    <section className="py-16 bg-gradient-to-br from-primary-50 to-secondary-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-text-primary mb-4">
            Real Couples, Real Success Stories
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto font-body">
            Discover how ShaadiNest helped thousands of couples create their perfect South Asian wedding celebrations.
          </p>
        </div>

        {/* Main Testimonial */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-white rounded-2xl shadow-strong border border-border overflow-hidden">
            <div className="lg:flex">
              {/* Image Section */}
              <div className="lg:w-1/2 h-64 lg:h-auto relative overflow-hidden">
                <Image
                  src={currentTestimonialData.image}
                  alt={`${currentTestimonialData.name} wedding`}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" />
                
                {/* Wedding Type Badge */}
                <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                  <span className="text-sm font-medium text-text-primary">
                    {currentTestimonialData.weddingType}
                  </span>
                </div>
              </div>

              {/* Content Section */}
              <div className="lg:w-1/2 p-8 lg:p-12">
                <div className="flex items-center space-x-1 mb-4">
                  {renderStars(currentTestimonialData.rating)}
                </div>

                <blockquote className="text-lg text-text-primary font-body mb-6 leading-relaxed">
                  "{currentTestimonialData.testimonial}"
                </blockquote>

                <div className="mb-6">
                  <h4 className="font-heading font-bold text-xl text-text-primary">
                    {currentTestimonialData.name}
                  </h4>
                  <p className="text-text-secondary font-caption flex items-center space-x-1">
                    <Icon name="MapPin" size={14} color="currentColor" />
                    <span>{currentTestimonialData.location}</span>
                  </p>
                </div>

                {/* Highlight */}
                <div className="bg-primary-50 rounded-lg p-4 mb-6">
                  <div className="flex items-center space-x-2">
                    <Icon name="Star" size={16} color="#8B4513" />
                    <span className="text-sm font-medium text-primary">
                      {currentTestimonialData.highlight}
                    </span>
                  </div>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center p-3 bg-surface-50 rounded-lg">
                    <div className="text-2xl font-bold text-primary font-heading">
                      {currentTestimonialData.vendorsBooked}
                    </div>
                    <div className="text-xs text-text-secondary font-caption">
                      Vendors Booked
                    </div>
                  </div>
                  <div className="text-center p-3 bg-surface-50 rounded-lg">
                    <div className="text-2xl font-bold text-success font-heading">
                      ${currentTestimonialData.savings.toLocaleString()}
                    </div>
                    <div className="text-xs text-text-secondary font-caption">
                      Money Saved
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Testimonial Navigation */}
        <div className="flex justify-center space-x-2 mb-12">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentTestimonial(index)}
              className={`w-3 h-3 rounded-full transition-smooth ${
                index === currentTestimonial ? 'bg-primary' : 'bg-border hover:bg-border-dark'
              }`}
            />
          ))}
        </div>

        {/* Additional Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.filter((_, index) => index !== currentTestimonial).slice(0, 3).map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white rounded-xl shadow-soft border border-border p-6 hover:shadow-medium transition-smooth cursor-pointer"
              onClick={() => setCurrentTestimonial(testimonials.findIndex(t => t.id === testimonial.id))}
            >
              <div className="flex items-center space-x-1 mb-3">
                {renderStars(testimonial.rating)}
              </div>
              
              <p className="text-text-primary font-body mb-4 line-clamp-3">
                "{testimonial.testimonial}"
              </p>
              
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-surface-100">
                  <Image
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h5 className="font-heading font-semibold text-text-primary text-sm">
                    {testimonial.name}
                  </h5>
                  <p className="text-xs text-text-secondary font-caption">
                    {testimonial.location}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Stats */}
        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl shadow-medium border border-border p-8">
            <h3 className="font-heading font-bold text-2xl text-text-primary mb-6">
              Join Our Community of Happy Couples
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              <div>
                <div className="text-3xl font-bold text-primary font-heading">98%</div>
                <div className="text-sm text-text-secondary font-caption">Satisfaction Rate</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary font-heading">4.9</div>
                <div className="text-sm text-text-secondary font-caption">Average Rating</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary font-heading">$3,200</div>
                <div className="text-sm text-text-secondary font-caption">Average Savings</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-primary font-heading">2 weeks</div>
                <div className="text-sm text-text-secondary font-caption">Average Planning Time</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;